<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">Material Details</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Back"
                    stylingMode="outlined"
                    type="normal"
                    (onClick)="cancel()"
                >
                </dx-button>
                <dx-button
                    class="ms-2"
                    text="Save"
                    stylingMode="contained"
                    type="default"
                    (onClick)="save()"
                >
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'material-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        @if (!isLoading) {
            <div class="form-container">
                <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
                    <div class="card-header fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent py-3">
                        <div>{{ material.description }}</div>
                        @if (material.number) {
                            <div class="text-muted">
                                ID: {{ material.number }}
                            </div>
                        }
                    </div>
                    <div class="card-body">
                        <!-- Top Section -->
                        <div class="row g-3 mx-3">
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <span class="fw-bold me-2">Status:</span>
                                    <span class="badge" [ngClass]="getStatusBadgeClass(material.status)">
                                        {{ material.status | capitalCase }}
                                    </span>
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Business Type:</span> {{ material.business }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Description:</span> {{ material.description }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <span class="fw-bold">Material Storage Type:</span> {{ material.storageType | capitalCase }}
                                </div>
                                <div class="mb-2 d-flex align-items-center">
                                    <span class="fw-bold me-2">Actual Material Storage Type:</span>
                                    <dx-select-box
                                        [(value)]="material.actualStorageType"
                                        [dataSource]="storageTypeOptions"
                                        [showClearButton]="true"
                                        displayExpr="text"
                                        valueExpr="value"
                                        width="200"
                                        stylingMode="filled"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </div>

                        <hr class="my-4" />

                        <!-- Shelf Life, Weight & Palletization -->
                        <div class="mb-3 fs-6">Shelf Life, Weight & Palletization</div>
                        <div class="row g-3 mx-3">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Client Tot Shelf Life:</span> {{ material.clientTotShelfLife }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Gross Weight:</span> {{ material.grossWeight | number:'1.2-2' }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Net Weight:</span> {{ material.netWeight | number:'1.2-2' }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Weight Type:</span> {{ material.weightType }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Unit:</span> {{ material.unit }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Sales Unit:</span> {{ material.salesUnit }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Eaches Per Sales Unit:</span> {{ material.eachesPerSalesUnit }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Pieces Per Pallet:</span> {{ material.piecesPerPallet }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Cases Per Layer:</span> {{ material.casesPerLayer }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Cases Per Pallet:</span> {{ material.casesPerPallet }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Layers Per Pallet:</span> {{ material.layersPerPallet }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Stacking Factor:</span> {{ material.stackingFactor }}
                                </div>
                            </div>
                        </div>

                         <hr class="my-4" />

                        <!-- Category & Hierarchy -->
                        <div class="mb-3 fs-6">Category & Hierarchy</div>
                        <div class="row g-3 mx-3">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Category:</span> {{ material.category }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Material Group:</span> {{ material.materialGroup }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Category Description:</span> {{ material.categoryDescription }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Hierarchy Description:</span> {{ material.hierarchyDescription }}
                                </div>
                            </div>
                        </div>

                        <hr class="my-4" />

                        <!-- Brand & Range -->
                        <div class="mb-3 fs-6">Brand & Range</div>
                        <div class="row g-3 mx-3">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">National Price:</span> {{ material.nationalPrice | currency }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Corporate Brand:</span> {{ material.corporateBrand }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Corporate Brand Description:</span> {{ material.corporateBrandDescription }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Range Brand:</span> {{ material.rangeBrand }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Range Brand Description:</span> {{ material.rangeBrandDescription }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Material Group:</span> {{ material.materialGroup }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <span class="fw-bold">Material Group Description:</span> {{ material.materialGroupDescription }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Nestec Product Category Name:</span> {{ material.nestecProductCategoryName }}
                                </div>
                                <div class="mb-2">
                                    <span class="fw-bold">Origin Description:</span> {{ material.originDescription }}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        }
    </dx-scroll-view>
</div>
